import { useQuery } from '@tanstack/react-query';
import { reportsService } from '@/services/reportsService';

export function useReports(year?: number) {
  return useQuery({
    queryKey: ['reports', year],
    queryFn: () => reportsService.getReports(year),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useReport(id: string | null) {
  return useQuery({
    queryKey: ['reports', id],
    queryFn: () => reportsService.getReport(id!),
    enabled: !!id,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export default {
  useReports,
  useReport,
};
